import React, { Component } from 'react'
import { shape, string, func } from 'prop-types'
import { connect } from 'react-redux'
import { Tooltip, FactorTooltip } from 'src/components/shared'
import { ReactComponent as Star } from 'src/images/star_white.svg'
import './Participate.scss'

export class Item extends Component {
  numbers = [0, 1, 2, 3, 4, 5]

  isSelected = (rowId, questionId, responses) => {
    const { selectedNums } = this.props

    if (selectedNums) return selectedNums[rowId] === questionId
    if (responses)
      return responses.find((resp) => resp.vote && resp.vote.user_vote)
    return false
  }

  onClick = (responseId) => () => {
    const { questionId, onClick } = this.props
    if (onClick) onClick(questionId, responseId)
  }

  render() {
    const { question, disabled } = this.props
    const { title, id: questionId, responses } = question
    const disablededClassName = disabled ? 'disabled' : ''
    const responseClassName = `creative_view__item-square_container ${disablededClassName}`
    const onClick = disabled ? () => {} : this.onClick

    return (
      <div className="creative_view__item">
        <FactorTooltip factor={question}>
          <label>{title}</label>
        </FactorTooltip>
        <div className={responseClassName}>
          {responses
            .sort((a, b) => a.numeric_value - b.numeric_value)
            .map(({ id, numeric_value, description }) => (
              <div
                key={numeric_value}
                onClick={onClick(id)}
                className={`square ${
                  this.isSelected(questionId, id, responses) ? 'chosen' : ''
                }`}
              >
                <Tooltip tooltip={description}>
                  <div>
                    {this.isSelected(questionId, id, responses) ? (
                      <Star />
                    ) : (
                      numeric_value
                    )}
                  </div>
                </Tooltip>
              </div>
            ))}
        </div>
      </div>
    )
  }
}

class CreativeView extends Component {
  render() {
    const { collection, selectedNums, onClick, disabled = false } = this.props

    return (
      <div className="creative_view">
        {collection.questions.map((item, idx) => (
          <Item
            key={idx}
            question={item}
            onClick={onClick}
            disabled={disabled}
            selectedNums={selectedNums}
          />
        ))}
      </div>
    )
  }
}

CreativeView.propTypes = {
  collection: shape({
    id: string.isRequired,
    title: string.isRequired,
  }),
  onClick: func,
}

CreativeView.defaultProps = {
  collection: {
    id: '',
    title: '',
    questions: [],
  },
  onClick: null,
}

const mapStateToProps = (state) => {
  return {
    collection: state.prioritize.collection,
  }
}

export default connect(mapStateToProps, {})(CreativeView)
